import React from "react";
import Layout from "../components/layout";
import { useStaticQuery, graphql } from "gatsby";
import { Card, Col, Alert } from "react-bootstrap";

const Contact = ({ info }) => {
  const itemsLen = info.items.length - 1;
  const contactItems = info.items.map((item, key) => {
    return (
      <Col>
        <a href={item.link}>{item.name}</a>
        {itemsLen !== key && <hr />}
      </Col>
    );
  });

  return (
    <Card>
      <Card.Header>{info.title}</Card.Header>
      <Card.Body>{contactItems}</Card.Body>
    </Card>
  );
};

const References = ({ info }) => {
  const itemsLen = info.items.length - 1;
  const contactItems = info.items.map((item, key) => {
    return (
      <Col>
        <div className="reference-name">{item.name}</div>
        <div className="reference-title">{item.position}</div>
        <div className="reference-org">{item.organization}</div>
        {itemsLen !== key && <hr />}
      </Col>
    );
  });
  return (
    <Card>
      <Card.Header>{info.title}</Card.Header>
      <Card.Body>
        <Alert variant="info">{info.info}</Alert>
        {contactItems}
      </Card.Body>
    </Card>
  );
};

const ContactPage = () => {
  const data = useStaticQuery(graphql`
    {
      dataYaml {
        contact {
          info {
            title
            items {
              name
              link
            }
          }
          references {
            title
            info
            items {
              name
              position
              organization
            }
          }
        }
      }
    }
  `).dataYaml.contact;

  return (
    <Layout title="Contact">
      <Contact info={data.info} />
      <References info={data.references} />
    </Layout>
  );
};

export default ContactPage;
